import { render, staticRenderFns } from "./ReportsPane.vue?vue&type=template&id=6bdd60fc&scoped=true&"
import script from "./ReportsPane.vue?vue&type=script&lang=js&"
export * from "./ReportsPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd60fc",
  null
  
)

export default component.exports